import { render, staticRenderFns } from "./genbyidea4.vue?vue&type=template&id=5218e41b&scoped=true"
import script from "./genbyidea4.vue?vue&type=script&lang=js"
export * from "./genbyidea4.vue?vue&type=script&lang=js"
import style0 from "./genbyidea4.vue?vue&type=style&index=0&id=5218e41b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5218e41b",
  null
  
)

export default component.exports